export const querySelectArray = (selector, scope = document) => {
    // eslint-disable-next-line no-restricted-properties
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
};
